
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import { ThemeProvider } from "./components/ui/theme-provider";
import { Toaster } from "@/components/ui/toaster";
import { ScrollToTop } from "./components/ScrollToTop";
import { ChurchBrandingProvider } from "./contexts/ChurchBrandingContext";

// Import pages
import Settings from "./pages/Settings";
import SermonPlansPage from "./pages/admin/SermonPlansPage";
import AISettingsPage from "./pages/admin/AISettingsPage";
import CongregationsPage from "./pages/admin/CongregationsPage";
import UsersPage from "./pages/admin/UsersPage";
import NotFound from "./pages/NotFound";
import Premium from "./pages/Premium";
import Give from "./pages/Give";
import GracefulPetitions from "./pages/GracefulPetitions";
import DailyDevotionals from "./pages/DailyDevotionals";
import Journal from "./pages/Journal";
import Journeys from "./pages/Journeys";
import BillingHistory from "./pages/BillingHistory";

// Import individual journey pages
import JourneyPeace from "./pages/JourneyPeace";
import JourneyHope from "./pages/JourneyHope";
import JourneyStrength from "./pages/JourneyStrength";
import JourneyJoy from "./pages/JourneyJoy";
import JourneyCourage from "./pages/JourneyCourage";
import JourneyGratitude from "./pages/JourneyGratitude";

function App() {
  return (
    <ThemeProvider defaultTheme="system" storageKey="grace-awakens-theme">
      <ChurchBrandingProvider>
        <div className="min-h-screen bg-app-background text-app-text-primary transition-colors duration-300">
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/admin/users" element={<UsersPage />} />
            <Route path="/admin/sermons" element={<SermonPlansPage />} />
            <Route path="/admin/ai-settings" element={<AISettingsPage />} />
            <Route path="/admin/congregations" element={<CongregationsPage />} />
            <Route path="/premium" element={<Premium />} />
            <Route path="/give" element={<Give />} />
            <Route path="/graceful-petitions" element={<GracefulPetitions />} />
            <Route path="/journeys" element={<Journeys />} />
            
            {/* Individual Journey Routes */}
            <Route path="/journey/peace" element={<JourneyPeace />} />
            <Route path="/journey/hope" element={<JourneyHope />} />
            <Route path="/journey/strength" element={<JourneyStrength />} />
            <Route path="/journey/joy" element={<JourneyJoy />} />
            <Route path="/journey/courage" element={<JourneyCourage />} />
            <Route path="/journey/gratitude" element={<JourneyGratitude />} />
            
            <Route path="/daily-devotionals" element={<DailyDevotionals />} />
            <Route path="/journal" element={<Journal />} />
            <Route path="/billing-history" element={<BillingHistory />} />
            {/* Add this wildcard route to catch all unmatched routes */}
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Toaster />
        </div>
      </ChurchBrandingProvider>
    </ThemeProvider>
  );
}

export default App;
